// Everyday items a plan price is compared to: "اشتراک ۱ ماهه = یه انرژی‌زا". One clear thing each, named in two or three
// words, never by weight or size and never as a count.
// Prices: owner (1405/07) where noted, otherwise Google results for Torob, Digikala, emalls and Tehran menu/price reports,
// checked 1405/07/27 (2026-10-19). Update a price here when the market moves; the picker re-matches automatically.
// image: /img/equivalents/<image>.webp (3D renders, transparent background).

export type EverydayItem = {
  slug: string;
  name: string; // with the indefinite article, as it reads after "به قیمت"
  price: number; // Toman (the middle of the band when one is known)
  band?: [number, number]; // a known price range: any plan price inside it matches this item
  image: string;
  source: string;
};

const item = (slug: string, name: string, price: number, source: string): EverydayItem => ({ slug, name, price, image: slug, source });
const banded = (base: EverydayItem, min: number, max: number): EverydayItem => ({ ...base, band: [min, max] });

export const ALL_ITEMS: EverydayItem[] = [
  item("chocolate", "یه شکلات", 65_000, "Torob: Farmand bar 65,000"),
  item("icecream", "یه بستنی", 80_000, "Mihan cone 70,000 to 96,000"),
  item("popcorn", "یه پاپ‌کورن", 90_000, "Huggles 55 g 90,000"),
  item("soda", "یه نوشابه خانواده", 105_000, "1.5 L cola: emalls 94,000, Digikala 111,000"),
  item("energy", "یه انرژی‌زا", 135_000, "Hype 250 ml 130,000 to 150,000"),
  item("espresso", "یه شات اسپرسو", 150_000, "owner, 1405/07"),
  item("cinema", "یه بلیط سینما", 150_000, "Kourosh/Charsou/Azadi 1405 floating price 90,000 to 180,000, 150,000 evenings (Asriran/ISNA, Mehr News)"),
  item("sandwich", "یه ساندویچ", 175_000, "rolled hot dog 175,000"),
  item("donut", "یه دونات", 180_000, "cafe donut 120,000 to 265,000"),
  item("coffee", "یه لاته", 250_000, "Lamiz small 248,800, Tehran mall food court 265,000 (Rokna, Ordibehesht 1405)"),
  // shortcut: undated cafe menus only (Raees 340,000 to 435,000, Mann 325,000, Donutim 175,000 to 210,000); replace with a dated 1405 source.
  item("milkshake", "یه میلک‌شیک", 330_000, "Tehran cafe menus, undated"),
  banded(item("croissant", "یه کروسان", 375_000, "owner, 1405/07: 350,000 to 400,000"), 350_000, 400_000),
  banded(item("burger", "یه همبرگر", 550_000, "owner, 1405/07: 400,000 to 700,000"), 400_000, 700_000),
  item("kebab", "یه جوجه کباب", 650_000, "restaurant joojeh 280,000 to 895,000"),
  item("birthdaycake", "یه کیک تولد", 800_000, "sanjagh.pro Mehr 1405, 1 kg: cream 694,000 to 790,000, semi-fondant 740,000 to 875,000"),
  banded(item("pizza", "یه پیتزا", 1_000_000, "owner, 1405/07: 1,000,000 (800,000 to 1,200,000)"), 800_000, 1_200_000),
];
